import { Observable } from "rxjs/index";
import { map } from "rxjs/operators";

import { FeaturesReachValueFlags, ViewedFeatureTrialDialogsFlags } from "@/services/DTOs";
import { MinosApiService } from "@/services/MinosApiService";
import { OpportunitiesApiService } from "@/services/OpportunitiesApiService";
import { trackAPICall } from "@/services/SnowplowService";
import { getId } from "@/utils/OpportunityUtils";

const signedInToOpportunitiesUrl =
  process.env.VUE_APP_DISCOVERY_ENVIRONMENT_MODE === "production"
    ? "/api/genome/people/opportunity-flag"
    : "/api/suite/users/me/opportunity-flag";
class Service {
  @trackAPICall("DELETE", "People", "flag", (args) => ({ flagName: args[0] }))
  public deleteFlag(flagName: string): Observable<void> {
    const url = `/api/suite/users/me/flags/${flagName}`;

    return OpportunitiesApiService.delete(url, {}).pipe(map(() => undefined));
  }

  @trackAPICall("PUT", "People", "flag", (args) => ({ flagName: args[0] }))
  public updateFlag(flagName: string, flagValue?: string): Observable<void> {
    const flagValueParam = flagValue ? `?flagValue=${flagValue}` : "";
    const url = `/api/suite/users/me/flags/${flagName}${flagValueParam}`;

    return OpportunitiesApiService.put(url, {}).pipe(map(() => undefined));
  }

  public getMemberTrialFeatureViewedFlags(opportunityId: string): Observable<ViewedFeatureTrialDialogsFlags> {
    const url = `/api/suite/opportunities/${getId(opportunityId)}/members-trial-feature-flags`;

    return OpportunitiesApiService.get(url)
      .pipe(map((response) => ({ ...response.data })));
  }

  public getDiscoveryFeaturesReachValueFlags(): Observable<FeaturesReachValueFlags> {
    const url = `/api/suite/users/me/features/reached-value`;

    return OpportunitiesApiService.get(url)
      .pipe(map((response) => ({ ...response.data })));
  }

  public getMinosFeaturesReachValueFlags(): Observable<FeaturesReachValueFlags> {
    const url = `/api/tiamat/minos/users/me/features/reached-value`;

    return MinosApiService.get(url)
      .pipe(map((response) => ({ ...response.data })));
  }

  public setMemberTrialFeatureViewedFlag(opportunityId: string, flagName: string, flagValue: string): Observable<void> {
    const url = `/api/suite/opportunities/${getId(opportunityId)}/members/flags/${flagName}?flagValue=${flagValue}`;

    return OpportunitiesApiService.put(url).pipe(map(() => undefined));
  }

  public updateMemberBooleanFlag(opportunityId: string, flagName: string, flagValue: boolean): Observable<void> {
    const url = `/api/suite/opportunities/${getId(opportunityId)}/members/boolean/flags/${flagName}?flagValue=${flagValue}`;

    return OpportunitiesApiService.put(url).pipe(map(() => undefined));
  }
}

export const FlagsService = new Service();
